import { render } from "./ProfileBody.vue?vue&type=template&id=a98fe10c&scoped=true"
import script from "./ProfileBody.vue?vue&type=script&lang=js"
export * from "./ProfileBody.vue?vue&type=script&lang=js"

import "./ProfileBody.vue?vue&type=style&index=0&id=a98fe10c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98fe10c"]])

export default __exports__